export class EAbort extends Error {
  name: string;
  message: string;
  stack?: string | undefined;
  cause?: Error | undefined;
  constructor(name?: string, message?: string, stack?: string | undefined, cause?: Error | undefined) {
    super(message ?? 'Operation Aborted');
    this.name = name ?? 'Abort';
    this.message = message ?? 'Operation Aborted';
    this.stack = stack;
    this.cause = cause;
  }
}
